import { createTheme } from "@mui/material";
import { theme } from "../../other/constants";

export const globalTheme = createTheme(theme);
